import React from 'react'
import { ParentNode, EndNode } from './Nodes'

export const getChildNodes = nodes => nodes.map(({ hide, ...node }) => {
  const Node = node.nodes ? ParentNode : EndNode
  if (hide) { return null }
  else { return <Node key={node.label} {...node} />
  }
})



// WEBPACK FOOTER //
// ./src/scripts/components/shared/Subnav/util.js